import { Component } from '@theme/component';

/**
 * Handles copying text to clipboard, from an event like a click.
 * Optionally, reveals a success message after copying.
 * @extends {Component}
 */
class CopyToClipboardComponent extends Component {
  copyToClipboard() {
    const copyContent = this.getAttribute('text-to-copy');

    if (!copyContent) return;

    navigator.clipboard.writeText(copyContent);

    const copySuccessMessage = this.refs.copySuccessMessage;

    if (copySuccessMessage instanceof HTMLElement) {
      copySuccessMessage.classList.remove('visually-hidden');

      const copySuccessTimeoutStr = copySuccessMessage.dataset.successTimeout
      const copySuccessTimeout = copySuccessTimeoutStr ? parseInt(copySuccessTimeoutStr, 10) : null;
      if (copySuccessTimeout) {
        setTimeout(() => {
            copySuccessMessage.classList.add('visually-hidden');
        }, copySuccessTimeout)
      }
    }
  }
}

if (!customElements.get('copy-to-clipboard-component')) {
  customElements.define('copy-to-clipboard-component', CopyToClipboardComponent);
}
